/**
 * Global Theme Enhancements
 * (Vehicle Title & Garage Synchronization with Brand Guard)
 */

document.addEventListener('DOMContentLoaded', () => {
  const ALLOWED_VEHICLE_BRANDS = ['audi', 'bmw', 'fiat', 'ford', 'mini', 'porsche', 'volkswagen'];

  function isValidVehicle(title, url) {
    if (!title && !url) return false;
    const cleanTitle = (title || '').toLowerCase();
    const cleanUrl = (url || '').toLowerCase();
    return ALLOWED_VEHICLE_BRANDS.some(brand => cleanTitle.includes(brand) || cleanUrl.includes(brand));
  }

  // ---------------------------------------------------------------------------
  // 0. Vehicle Database Loaded Event Trigger
  // ---------------------------------------------------------------------------
  function checkVehicleDb() {
    if (window.vehicleDb) {
      document.dispatchEvent(new CustomEvent('vehicleDb:loaded', { bubbles: true }));
    }
  }
  checkVehicleDb();
  setTimeout(checkVehicleDb, 200);

  // ---------------------------------------------------------------------------
  // 1. Full Vehicle & Collection Title Formatter
  // ---------------------------------------------------------------------------
  window.formatFullVehicleTitle = function(url, rawTitle) {
    const isProductPage = window.location.pathname.includes('/products/');
    const isCollectionPage = window.location.pathname.includes('/collections/');
    const db = window.vehicleDb;

    // 1. Direct DB lookup for the URL to extract model title
    if (db && url) {
      for (const make in db) {
        for (const series in db[make]) {
          for (const gen in db[make][series]) {
            const match = db[make][series][gen].find((i) => i.url === url);
            if (match && match.title) {
              const fullDbTitle = match.title.startsWith(make) ? match.title : `${make} ${match.title}`;
              if (isValidVehicle(fullDbTitle, url)) {
                return fullDbTitle;
              }
            }
          }
        }
      }
    }

    // 2. On collection pages, grab live collection title ONLY if it's a vehicle collection
    if (isCollectionPage && !isProductPage) {
      const fitmentActiveRow = document.querySelector('.fitment-table__row--active[data-collection-title]');
      if (fitmentActiveRow) {
        const fitmentTitle = fitmentActiveRow.getAttribute('data-collection-title');
        if (isValidVehicle(fitmentTitle, window.location.pathname)) {
          return fitmentTitle;
        }
      }

      const collectionH1 = document.querySelector('h1.collection__title, .collection-hero__title, .page__title, h1');
      if (collectionH1 && collectionH1.textContent.trim()) {
        const liveH1Title = collectionH1.textContent.trim();
        if (isValidVehicle(liveH1Title, window.location.pathname)) {
          return liveH1Title;
        }
      }
    }

    // 3. Fallback to rawTitle if valid vehicle brand
    if (rawTitle && rawTitle.trim() !== '') {
      if (isValidVehicle(rawTitle, url)) {
        return rawTitle.trim();
      }
    }

    return '';
  };

  // ---------------------------------------------------------------------------
  // 2. Active Vehicle Badge UI Sync
  // ---------------------------------------------------------------------------
  function updateVehicleBadgeUI() {
    const badgeElements = document.querySelectorAll('.vehicle-selector__active-vehicle, [data-active-vehicle-badge], .custom-vehicle-badge, #vf-mobile-summary');
    if (!badgeElements.length) return;

    try {
      let activeTitle = '';

      const savedSession = sessionStorage.getItem('selected_vehicle_data');
      if (savedSession) {
        const parsedSession = JSON.parse(savedSession);
        if (parsedSession && parsedSession.title && isValidVehicle(parsedSession.title, parsedSession.url)) {
          activeTitle = window.formatFullVehicleTitle(parsedSession.url, parsedSession.title);
        } else {
          // Purge invalid non-vehicle session data
          sessionStorage.removeItem('selected_vehicle_data');
          sessionStorage.removeItem('selected_vehicle_title');
        }
      }

      if (!activeTitle) {
        const rawGarage = localStorage.getItem('my_user_garage');
        if (rawGarage) {
          const garage = JSON.parse(rawGarage);
          if (Array.isArray(garage) && garage.length > 0) {
            const activeVehicle = garage.find(item => item.active && isValidVehicle(item.title, item.url)) || garage.find(item => isValidVehicle(item.title, item.url));
            if (activeVehicle && activeVehicle.title) {
              activeTitle = window.formatFullVehicleTitle(activeVehicle.url, activeVehicle.title);
            }
          }
        }
      }

      badgeElements.forEach(elem => {
        if (activeTitle) {
          elem.textContent = activeTitle;
          elem.style.display = 'inline-block';
        } else {
          elem.style.display = 'none';
        }
      });
    } catch (e) {
      console.error('Error updating vehicle badge:', e);
    }
  }

  document.addEventListener('vehicle:changed', updateVehicleBadgeUI);
  document.addEventListener('vehicleDb:loaded', updateVehicleBadgeUI);
  updateVehicleBadgeUI();
  setTimeout(updateVehicleBadgeUI, 300);
});

/**
 * Dynamic Multi-Option Swatch SKU Switcher with Visual Animation
 */
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', (event) => {
    const target = event.target;
    
    // 1. Verify click target is a swatch radio button
    if (!target.classList.contains('color-swatch__radio')) return;

    // 2. Locate parent product item card
    const card = target.closest('.product-item');
    if (!card) return;

    const rawVariantData = card.getAttribute('data-variants-json');
    if (!rawVariantData) return;

    try {
      const variants = JSON.parse(rawVariantData);
      
      // 3. Gather checked swatch values inside this card
      const selectedOptions = [];
      const checkedRadios = card.querySelectorAll('.color-swatch__radio:checked');
      
      checkedRadios.forEach((radio) => {
        if (radio.value) {
          selectedOptions.push(radio.value.trim());
        }
      });

      if (selectedOptions.length === 0) return;

      // 4. Match selected options to the variant matrix
      const matchedVariant = variants.find((variant) => {
        return selectedOptions.every((selectedVal) => {
          return (
            variant.option1 === selectedVal ||
            variant.option2 === selectedVal ||
            variant.option3 === selectedVal
          );
        });
      });

      // 5. If variant has a valid SKU, update text and restart animation
      if (matchedVariant && matchedVariant.sku) {
        const skuElement = card.querySelector('.product-meta__sku-number');
        if (skuElement) {
          // Update text content
          skuElement.textContent = matchedVariant.sku;
          
          // Force CSS reflow to restart keyframe animation on consecutive clicks
          skuElement.classList.remove('sku-flash');
          void skuElement.offsetWidth; 
          skuElement.classList.add('sku-flash');
        }
      }
    } catch (error) {
      console.error('Error parsing card variant JSON:', error);
    }
  });
});